import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["data"]
  connect(){
    // console.log("Hello World!")
  }
  updateValue(){
    const targets = this.dataTargets
    console.log('[update-field-value] updateValue called, targets:', targets.length)
    targets.forEach((e) => {
      var newValue = e.getAttribute('data-value')
      var formField = e.getAttribute('data-id')
      console.log('[update-field-value] Setting', formField, 'to', newValue)
      document.getElementById(formField).value = newValue;
    })
  }
};